import React from 'react'
import Main from './components/Main';
import { PluginHarness } from '@missionlabs/smartagent-app-components';

const devContact = {
    "sa-facia": 'jdsportsuk',
    "ID": "definitely-a-real-ID-i-promise"
}

const App : React.FC<{}> = () => {

    const isEmbedded = window.parent !== window;

    return (
        <>
            {isEmbedded
                ? <Main />
                : <PluginHarness contact={devContact}>
                      <Main />
                  </PluginHarness>}
        </>
    )
}

export default App;
